import { html } from 'lit';
import store from './store';
import { playVideo as playVideoAction } from './store';

const playVideo = (event, postId) => {
  event.preventDefault();
  const video = event.currentTarget.querySelector('video');
  if (video) {
    store.dispatch(playVideoAction(postId));
    // If video is already playing, toggle mute/unmute
    if (video.paused) {
      video.play();
    } else {
      video.muted = !video.muted;
      // const volumeHigh = event.currentTarget.parentElement.querySelector('.volume-high');
      // const volumeOff = event.currentTarget.parentElement.querySelector('.volume-off');
      // volumeHigh.classList.toggle('slds-show', !video.muted);
      // volumeHigh.classList.toggle('slds-hide', video.muted);
      // volumeOff.classList.toggle('slds-show', video.muted);
      // volumeOff.classList.toggle('slds-hide', !video.muted);
    }
  }
}

const toggleSound = (event) => {
  event.preventDefault();
  const video = event.currentTarget.parentElement.querySelector('video');
  if (video) {
    video.muted = !video.muted;
    // const volumeHigh = event.currentTarget.parentElement.querySelector('.volume-high');
    // const volumeOff = event.currentTarget.parentElement.querySelector('.volume-off');
    // volumeHigh.classList.toggle('slds-show', !video.muted);
    // volumeHigh.classList.toggle('slds-hide', video.muted);
    // volumeOff.classList.toggle('slds-show', video.muted);
    // volumeOff.classList.toggle('slds-hide', !video.muted);
    window.muteByDefault = video.muted;
  }
}

const setVolume = (event) => {
  const video = event.currentTarget.parentElement.querySelector('video');
  if (video) {
    const volumeHigh = event.currentTarget.parentElement.parentElement.parentElement.querySelector('.volume-high');
    const volumeOff = event.currentTarget.parentElement.parentElement.parentElement.querySelector('.volume-off');
    const isMuted = video.muted || video.volume === 0;
    volumeHigh.classList.toggle('slds-show', !isMuted);
    volumeHigh.classList.toggle('slds-hide', isMuted);
    volumeOff.classList.toggle('slds-show', isMuted);
    volumeOff.classList.toggle('slds-hide', !isMuted);
    window.muteByDefault = isMuted;
  }
}

const setVideoLength = (event, a, b) => {
  const video = event.currentTarget;
  if (video) {
    const length = video.duration;
    const minutes = Math.floor(length / 60);
    const seconds = Math.floor(length % 60);
    const lengthString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    const lengthElement = event.currentTarget.parentElement.querySelector('.length');
    if (lengthElement) {
      lengthElement.textContent = lengthString;
    }
  }
}

const hideButton = (event) => {
  const button = event.currentTarget.parentElement.querySelector('.presenting');
  if (button) {
    button.style.display = 'none';
  }
  // Fade out length
  const lengthElement = event.currentTarget.parentElement.querySelector('.length');
  if (lengthElement) {
    lengthElement.style.opacity = '1';
    setTimeout(() => {
      lengthElement.style.opacity = '0';
    }, 5000);
  }
}

const showButton = (event) => {
  const button = event.currentTarget.parentElement.querySelector('.presenting');
  if (button) {
    button.style.display = 'block';
  }
  // Fade out length
  const lengthElement = event.currentTarget.parentElement.querySelector('.length');
  if (lengthElement) {
    lengthElement.style.opacity = '1';
  }
}

export const getVideoOrImage = (files, alt, url, openDialog, autoPlay) => {
  if (files && (files.default || files.undefined)) {
    const fileArray = files.default || files.undefined;
    const fileUrl = fileArray.file_url;
    const ext = fileUrl.split(".").pop();
    if (ext === "webp") {
      if (openDialog) {
        return html`
          <a @click="${openDialog}" href="/post/${url}">
            <div class="background">
            <img src="${fileUrl}" alt="${alt}" oncontextmenu="return false;">
            </div>
          </a>`;
      } else {
        return html`<div class="background"><img src="${fileUrl}" alt="${alt}" oncontextmenu="return false;"></div>`;
      }
    }
    else if (ext === "webm") {
      return html`
      <div class="slds-is-relative">
        <a @click="${(event) => playVideo(event, url)}">
          <div class="background">
            <video ?autoplay=${autoPlay} muted preload="auto" playsinline loop @loadedmetadata="${setVideoLength}" @play="${hideButton}" @pause="${showButton}" @volumechange="${setVolume}">
              <source src="${fileUrl}" type="video/webm">
              Your browser does not support the video tag.
            </video>
            <p class="length"></p>
            <div class="presenting">
              <span class="presenting-icon">
                <svg class="slds-icon slds-icon_x-large" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#play"></use>
                </svg>
              </span>
            </div>
          </div>
        </a>
        <a href="javascript:void(0)" @click="${toggleSound}" class="sound-toggle">
          <span class="sound-toggle-icon">
            <svg class="slds-icon slds-icon_small slds-hide volume-high slds-p-around_xxx-small" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#volume_high"></use>
            </svg>
            <svg class="slds-icon slds-icon_small slds-show volume-off slds-p-around_xxx-small" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#volume_off"></use>
            </svg>
          </span>
        </a>
      </div>`;
    }
    // files.default
    // debugger;
  }
  else {
    return html`<div class="background">
        <div role="status" class="slds-spinner slds-spinner_medium">
        <span class="slds-assistive-text">Loading</span>
        <div class="slds-spinner__dot-a"></div>
        <div class="slds-spinner__dot-b"></div>
      </div>
    </div>`;
  }
}

export const getTimePassed = (date) => {
    if (!date) { return ''; }
    if (typeof date === 'string') {
      date = new Date(date);
    }
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) {
      return `${years} year${years === 1 ? '' : 's'} ago`;
    } else if (months > 0) {
      return `${months} month${months === 1 ? '' : 's'} ago`;
    } else if (days > 0) {
      return `${days} day${days === 1 ? '' : 's'} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    } else {
      return 'Less than a minute ago';
    }
}

export const debounce = (callback, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(...args), delay);
  };
}

export const locationArray = [
  {title: "Select Location...", id: ""},
  {title: "Afghanistan", id: "afghanistan"},
  {title: "Åland Islands", id: "aland_islands"},
  {title: "Albania", id: "albania"},
  {title: "Algeria", id: "algeria"},
  {title: "American Samoa", id: "american_samoa"},
  {title: "Andorra", id: "andorra"},
  {title: "Angola", id: "angola"},
  {title: "Anguilla", id: "anguilla"},
  {title: "Antarctica", id: "antarctica"},
  {title: "Antigua & Barbuda", id: "antigua_barbuda"},
  {title: "Argentina", id: "argentina"},
  {title: "Armenia", id: "armenia"},
  {title: "Aruba", id: "aruba"},
  {title: "Australia", id: "australia"},
  {title: "Austria", id: "austria"},
  {title: "Azerbaijan", id: "azerbaijan"},
  {title: "Bahamas", id: "bahamas"},
  {title: "Bahrain", id: "bahrain"},
  {title: "Bangladesh", id: "bangladesh"},
  {title: "Barbados", id: "barbados"},
  {title: "Belarus", id: "belarus"},
  {title: "Belgium", id: "belgium"},
  {title: "Belize", id: "belize"},
  {title: "Benin", id: "benin"},
  {title: "Bermuda", id: "bermuda"},
  {title: "Bhutan", id: "bhutan"},
  {title: "Bolivia", id: "bolivia"},
  {title: "Bosnia & Herzegovina", id: "bosnia_herzegovina"},
  {title: "Botswana", id: "botswana"},
  {title: "Bouvet Island", id: "bouvet_island"},
  {title: "Brazil", id: "brazil"},
  {title: "British Indian Ocean Territory", id: "british_indian_ocean_territory"},
  {title: "Brunei", id: "brunei"},
  {title: "Bulgaria", id: "bulgaria"},
  {title: "Burkina Faso", id: "burkina_faso"},
  {title: "Burundi", id: "burundi"},
  {title: "Cambodia", id: "cambodia"},
  {title: "Cameroon", id: "cameroon"},
  {title: "Canada", id: "canada"},
  {title: "Cape Verde", id: "cape_verde"},
  {title: "Caribbean Netherlands", id: "caribbean_netherlands"},
  {title: "Cayman Islands", id: "cayman_islands"},
  {title: "Central African Republic", id: "central_african_republic"},
  {title: "Chad", id: "chad"},
  {title: "Chile", id: "chile"},
  {title: "China", id: "china"},
  {title: "Christmas Island", id: "christmas_island"},
  {title: "Cocos (Keeling) Islands", id: "cocos_keeling_islands"},
  {title: "Colombia", id: "colombia"},
  {title: "Comoros", id: "comoros"},
  {title: "Congo - Brazzaville", id: "congo_brazzaville"},
  {title: "Congo - Kinshasa", id: "congo_kinshasa"},
  {title: "Cook Islands", id: "cook_islands"},
  {title: "Costa Rica", id: "costa_rica"},
  {title: "Côte d’Ivoire", id: "cote_d_ivoire"},
  {title: "Croatia", id: "croatia"},
  {title: "Cuba", id: "cuba"},
  {title: "Curaçao", id: "curacao"},
  {title: "Cyprus", id: "cyprus"},
  {title: "Czechia", id: "czechia"},  
  {title: "Denmark", id: "denmark"},
  {title: "Djibouti", id: "djibouti"},
  {title: "Dominica", id: "dominica"},
  {title: "Dominican Republic", id: "dominican_republic"},
  {title: "Ecuador", id: "ecuador"},
  {title: "Egypt", id: "egypt"},
  {title: "El Salvador", id: "el_salvador"},
  {title: "Equatorial Guinea", id: "equatorial_guinea"},
  {title: "Eritrea", id: "eritrea"},
  {title: "Estonia", id: "estonia"},
  {title: "Eswatini", id: "eswatini"},
  {title: "Ethiopia", id: "ethiopia"},
  {title: "Falkland Islands", id: "falkland_islands"},
  {title: "Faroe Islands", id: "faroe_islands"},
  {title: "Fiji", id: "fiji"},
  {title: "Finland", id: "finland"},
  {title: "France", id: "france"},
  {title: "French Guiana", id: "french_guiana"},
  {title: "French Polynesia", id: "french_polynesia"},
  {title: "French Southern Territories", id: "french_southern_territories"},
  {title: "Gabon", id: "gabon"},
  {title: "Gambia", id: "gambia"},
  {title: "Georgia", id: "georgia"},
  {title: "Germany", id: "germany"},
  {title: "Ghana", id: "ghana"},
  {title: "Gibraltar", id: "gibraltar"},
  {title: "Greece", id: "greece"},
  {title: "Greenland", id: "greenland"},
  {title: "Grenada", id: "grenada"},
  {title: "Guadeloupe", id: "guadeloupe"},
  {title: "Guam", id: "guam"},
  {title: "Guatemala", id: "guatemala"},
  {title: "Guernsey", id: "guernsey"},
  {title: "Guinea", id: "guinea"},
  {title: "Guinea-Bissau", id: "guinea_bissau"},
  {title: "Guyana", id: "guyana"},
  {title: "Haiti", id: "haiti"},
  {title: "Heard Island & McDonald Islands", id: "heard_island_mcdonald_islands"},
  {title: "Honduras", id: "honduras"},
  {title: "Hong Kong SAR China", id: "hong_kong_sar_china"},
  {title: "Hungary", id: "hungary"},
  {title: "Iceland", id: "iceland"},
  {title: "India", id: "india"},
  {title: "Indonesia", id: "indonesia"},
  {title: "Iran", id: "iran"},
  {title: "Iraq", id: "iraq"},
  {title: "Ireland", id: "ireland"},
  {title: "Isle of Man", id: "isle_of_man"},
  {title: "Israel", id: "israel"},
  {title: "Italy", id: "italy"},
  {title: "Jamaica", id: "jamaica"},
  {title: "Japan", id: "japan"},
  {title: "Jersey", id: "jersey"},
  {title: "Jordan", id: "jordan"},
  {title: "Kazakhstan", id: "kazakhstan"},
  {title: "Kenya", id: "kenya"},
  {title: "Kiribati", id: "kiribati"},
  {title: "Kuwait", id: "kuwait"},
  {title: "Kyrgyzstan", id: "kyrgyzstan"},
  {title: "Laos", id: "laos"},
  {title: "Latvia", id: "latvia"},
  {title: "Lebanon", id: "lebanon"},
  {title: "Lesotho", id: "lesotho"},
  {title: "Liberia", id: "liberia"},
  {title: "Libya", id: "libya"},
  {title: "Liechtenstein", id: "liechtenstein"},
  {title: "Lithuania", id: "lithuania"},
  {title: "Luxembourg", id: "luxembourg"},
  {title: "Macao SAR China", id: "macao_sar_china"},
  {title: "Madagascar", id: "madagascar"},
  {title: "Malawi", id: "malawi"},
  {title: "Malaysia", id: "malaysia"},
  {title: "Maldives", id: "maldives"},
  {title: "Mali", id: "mali"},
  {title: "Malta", id: "malta"},
  {title: "Marshall Islands", id: "marshall_islands"},
  {title: "Martinique", id: "martinique"},
  {title: "Mauritania", id: "mauritania"},
  {title: "Mauritius", id: "mauritius"},
  {title: "Mayotte", id: "mayotte"},
  {title: "Mexico", id: "mexico"},
  {title: "Micronesia", id: "micronesia"},
  {title: "Moldova", id: "moldova"},
  {title: "Monaco", id: "monaco"},
  {title: "Mongolia", id: "mongolia"},
  {title: "Montenegro", id: "montenegro"},
  {title: "Montserrat", id: "montserrat"},
  {title: "Morocco", id: "morocco"},
  {title: "Mozambique", id: "mozambique"},
  {title: "Myanmar", id: "myanmar"},
  {title: "Namibia", id: "namibia"},
  {title: "Nauru", id: "nauru"},
  {title: "Nepal", id: "nepal"},
  {title: "Netherlands", id: "netherlands"},
  {title: "New Caledonia", id: "new_caledonia"},
  {title: "New Zealand", id: "new_zealand"},
  {title: "Nicaragua", id: "nicaragua"},
  {title: "Niger", id: "niger"},
  {title: "Nigeria", id: "nigeria"},
  {title: "Niue", id: "niue"},
  {title: "Norfolk Island", id: "norfolk_island"},
  {title: "North Macedonia", id: "north_macedonia"},
  {title: "Northern Mariana Islands", id: "northern_mariana_islands"},
  {title: "Norway", id: "norway"},
  {title: "Oman", id: "oman"},
  {title: "Pakistan", id: "pakistan"},
  {title: "Palau", id: "palau"},
  {title: "Palestinian Territories", id: "palestinian_territories"},
  {title: "Panama", id: "panama"},
  {title: "Papua New Guinea", id: "papua_new_guinea"},
  {title: "Paraguay", id: "paraguay"},
  {title: "Peru", id: "peru"},
  {title: "Philippines", id: "philippines"},
  {title: "Pitcairn Islands", id: "pitcairn_islands"},
  {title: "Poland", id: "poland"},
  {title: "Portugal", id: "portugal"},
  {title: "Puerto Rico", id: "puerto_rico"},
  {title: "Qatar", id: "qatar"},
  {title: "Réunion", id: "reunion"},
  {title: "Romania", id: "romania"},
  {title: "Russia", id: "russia"},
  {title: "Rwanda", id: "rwanda"},
  {title: "Samoa", id: "samoa"},
  {title: "San Marino", id: "san_marino"},
  {title: "São Tomé & Príncipe", id: "sao_tome_principe"},
  {title: "Saudi Arabia", id: "saudi_arabia"},
  {title: "Senegal", id: "senegal"},
  {title: "Serbia", id: "serbia"},
  {title: "Seychelles", id: "seychelles"},
  {title: "Sierra Leone", id: "sierra_leone"},
  {title: "Singapore", id: "singapore"},
  {title: "Sint Maarten", id: "sint_maarten"},
  {title: "Slovakia", id: "slovakia"},
  {title: "Slovenia", id: "slovenia"},
  {title: "Solomon Islands", id: "solomon_islands"},
  {title: "Somalia", id: "somalia"},
  {title: "South Africa", id: "south_africa"},
  {title: "South Georgia & South Sandwich Islands", id: "south_georgia_south_sandwich_islands"},
  {title: "South Korea", id: "south_korea"},
  {title: "South Sudan", id: "south_sudan"},
  {title: "Spain", id: "spain"},
  {title: "Sri Lanka", id: "sri_lanka"},
  {title: "St. Barthélemy", id: "st_barthlemy"},
  {title: "St. Helena", id: "st_helena"},
  {title: "St. Kitts & Nevis", id: "st_kitts_nevis"},
  {title: "St. Lucia", id: "st_lucia"},
  {title: "St. Martin", id: "st_martin"},
  {title: "St. Pierre & Miquelon", id: "st_pierre_miquelon"},
  {title: "St. Vincent & Grenadines", id: "st_vincent_grenadines"},
  {title: "Sudan", id: "sudan"},
  {title: "Suriname", id: "suriname"},
  {title: "Svalbard & Jan Mayen", id: "svalbard_jan_mayen"},
  {title: "Sweden", id: "sweden"},
  {title: "Switzerland", id: "switzerland"},
  {title: "Taiwan", id: "taiwan"},
  {title: "Syria", id: "syria"},
  {title: "Tajikistan", id: "tajikistan"},
  {title: "Tanzania", id: "tanzania"},
  {title: "Thailand", id: "thailand"},
  {title: "Timor-Leste", id: "timor_leste"},
  {title: "Togo", id: "togo"},
  {title: "Tokelau", id: "tokelau"},
  {title: "Tonga", id: "tonga"},
  {title: "Trinidad & Tobago", id: "trinidad_tobago"},
  {title: "Tunisia", id: "tunisia"},
  {title: "Turkey", id: "turkey"},
  {title: "Turkmenistan", id: "turkmenistan"},
  {title: "Turks & Caicos Islands", id: "turks_caicos_islands"},
  {title: "Tuvalu", id: "tuvalu"},
  {title: "Uganda", id: "uganda"},
  {title: "Ukraine", id: "ukraine"},
  {title: "United Arab Emirates", id: "united_arab_emirates"},
  {title: "United Kingdom", id: "united_kingdom"},
  {title: "United States", id: "united_states"},
  {title: "United States Minor Outlying Islands", id: "united_states_minor_outlying_islands"},
  {title: "Uruguay", id: "uruguay"},
  {title: "Uzbekistan", id: "uzbekistan"},
  {title: "Vanuatu", id: "vanuatu"},
  {title: "Vatican City", id: "vatican_city"},
  {title: "Venezuela", id: "venezuela"},
  {title: "Vietnam", id: "vietnam"},
  {title: "Virgin Islands, British", id: "virgin_islands_british"},
  {title: "Virgin Islands, U.S.", id: "virgin_islands_us"},
  {title: "Wallis & Futuna", id: "wallis_futuna"},
  {title: "Western Sahara", id: "western_sahara"},
  {title: "Yemen", id: "yemen"},
  {title: "Zambia", id: "zambia"},
  {title: "Zimbabwe", id: "zimbabwe"}
];

export const statusArray = [
  {title: "None", id: "none"},
  {title: "🇦🇩 Andorra", id: "andorra"},
  {title: "🇦🇪 United Arab Emirates", id: "united_arab_emirates"},
  {title: "🇦🇫 Afghanistan", id: "afghanistan"},
  {title: "🇦🇬 Antigua & Barbuda", id: "antigua_barbuda"},
  {title: "🇦🇮 Anguilla", id: "anguilla"},
  {title: "🇦🇱 Albania", id: "albania"},
  {title: "🇦🇲 Armenia", id: "armenia"},
  {title: "🇦🇴 Angola", id: "angola"},
  {title: "🇦🇶 Antarctica", id: "antarctica"},
  {title: "🇦🇷 Argentina", id: "argentina"},
  {title: "🇦🇸 American Samoa", id: "american_samoa"},
  {title: "🇦🇹 Austria", id: "austria"},
  {title: "🇦🇺 Australia", id: "australia"},
  {title: "🇦🇼 Aruba", id: "aruba"},
  {title: "🇦🇿 Azerbaijan", id: "azerbaijan"},
  {title: "🇧🇦 Bosnia & Herzegovina", id: "bosnia_herzegovina"},
  {title: "🇧🇧 Barbados", id: "barbados"},
  {title: "🇧🇩 Bangladesh", id: "bangladesh"},
  {title: "🇧🇪 Belgium", id: "belgium"},
  {title: "🇧🇫 Burkina Faso", id: "burkina_faso"},
  {title: "🇧🇬 Bulgaria", id: "bulgaria"},
  {title: "🇧🇭 Bahrain", id: "bahrain"},
  {title: "🇧🇮 Burundi", id: "burundi"},
  {title: "🇧🇯 Benin", id: "benin"},
  {title: "🇧🇱 St. Barthélemy", id: "st_barthelemy"},
  {title: "🇧🇲 Bermuda", id: "bermuda"},
  {title: "🇧🇳 Brunei", id: "brunei"},
  {title: "🇧🇴 Bolivia", id: "bolivia"},
  {title: "🇧🇶 Caribbean Netherlands", id: "caribbean_netherlands"},
  {title: "🇧🇷 Brazil", id: "brazil"},
  {title: "🇧🇸 Bahamas", id: "bahamas"},
  {title: "🇧🇹 Bhutan", id: "bhutan"},
  {title: "🇧🇼 Botswana", id: "botswana"},
  {title: "🇧🇾 Belarus", id: "belarus"},
  {title: "🇧🇿 Belize", id: "belize"},
  {title: "🇨🇦 Canada", id: "canada"},
  {title: "🇨🇩 Congo - Kinshasa", id: "congo_kinshasa"},
  {title: "🇨🇬 Congo - Brazzaville", id: "congo_brazzaville"},
  {title: "🇨🇭 Switzerland", id: "switzerland"},
  {title: "🇨🇱 Chile", id: "chile"},
  {title: "🇨🇲 Cameroon", id: "cameroon"},
  {title: "🇨🇳 China", id: "china"},
  {title: "🇨🇴 Colombia", id: "colombia"},
  {title: "🇨🇷 Costa Rica", id: "costa_rica"},
  {title: "🇨🇺 Cuba", id: "cuba"},
  {title: "🇨🇻 Cape Verde", id: "cape_verde"},
  {title: "🇨🇼 Curaçao", id: "curacao"},
  {title: "🇨🇾 Cyprus", id: "cyprus"},
  {title: "🇨🇿 Czechia", id: "czechia"},
  {title: "🇩🇪 Germany", id: "germany"},
  {title: "🇩🇬 Diego Garcia", id: "diego_garcia"},
  {title: "🇩🇯 Djibouti", id: "djibouti"},
  {title: "🇩🇰 Denmark", id: "denmark"},
  {title: "🇩🇲 Dominica", id: "dominica"},
  {title: "🇩🇴 Dominican Republic", id: "dominican_republic"},
  {title: "🇩🇿 Algeria", id: "algeria"},
  {title: "🇪🇦 Ceuta & Melilla", id: "ceuta_melilla"},
  {title: "🇪🇨 Ecuador", id: "ecuador"},
  {title: "🇪🇪 Estonia", id: "estonia"},
  {title: "🇪🇬 Egypt", id: "egypt"},
  {title: "🇪🇭 Western Sahara", id: "western_sahara"},
  {title: "🇪🇷 Eritrea", id: "eritrea"},
  {title: "🇪🇸 Spain", id: "spain"},
  {title: "🇪🇹 Ethiopia", id: "ethiopia"},
  {title: "🇪🇺 European Union", id: "european_union"},
  {title: "🇫🇮 Finland", id: "finland"},
  {title: "🇫🇯 Fiji", id: "fiji"},
  {title: "🇫🇲 Micronesia", id: "micronesia"},
  {title: "🇫🇷 France", id: "france"},
  {title: "🇬🇦 Gabon", id: "gabon"},
  {title: "🇬🇧 United Kingdom", id: "united_kingdom"},
  {title: "🇬🇩 Grenada", id: "grenada"},
  {title: "🇬🇪 Georgia", id: "georgia"},
  {title: "🇬🇫 French Guiana", id: "french_guiana"},
  {title: "🇬🇬 Guernsey", id: "guernsey"},
  {title: "🇬🇭 Ghana", id: "ghana"},
  {title: "🇬🇮 Gibraltar", id: "gibraltar"},
  {title: "🇬🇱 Greenland", id: "greenland"},
  {title: "🇬🇲 Gambia", id: "gambia"},
  {title: "🇬🇳 Guinea", id: "guinea"},
  {title: "🇬🇵 Guadeloupe", id: "guadeloupe"},
  {title: "🇬🇶 Equatorial Guinea", id: "equatorial_guinea"},
  {title: "🇬🇷 Greece", id: "greece"},
  {title: "🇬🇹 Guatemala", id: "guatemala"},
  {title: "🇬🇺 Guam", id: "guam"},
  {title: "🇬🇼 Guinea-Bissau", id: "guinea_bissau"},
  {title: "🇬🇾 Guyana", id: "guyana"},
  {title: "🇭🇰 Hong Kong", id: "hong_kong"},
  {title: "🇭🇳 Honduras", id: "honduras"},
  {title: "🇭🇷 Croatia", id: "croatia"},
  {title: "🇭🇹 Haiti", id: "haiti"},
  {title: "🇭🇺 Hungary", id: "hungary"},
  {title: "🇮🇩 Indonesia", id: "indonesia"},
  {title: "🇮🇪 Ireland", id: "ireland"},
  {title: "🇮🇱 Israel", id: "israel"},
  {title: "🇮🇲 Isle of Man", id: "isle_of_man"},
  {title: "🇮🇳 India", id: "india"},
  {title: "🇮🇶 Iraq", id: "iraq"},
  {title: "🇮🇷 Iran", id: "iran"},
  {title: "🇮🇸 Iceland", id: "iceland"},
  {title: "🇮🇹 Italy", id: "italy"},
  {title: "🇯🇪 Jersey", id: "jersey"},
  {title: "🇯🇲 Jamaica", id: "jamaica"},
  {title: "🇯🇴 Jordan", id: "jordan"},
  {title: "🇯🇵 Japan", id: "japan"},
  {title: "🇰🇪 Kenya", id: "kenya"},
  {title: "🇰🇬 Kyrgyzstan", id: "kyrgyzstan"},
  {title: "🇰🇭 Cambodia", id: "cambodia"},
  {title: "🇰🇮 Kiribati", id: "kiribati"},
  {title: "🇰🇲 Comoros", id: "comoros"},
  {title: "🇰🇵 North Korea", id: "north_korea"},
  {title: "🇰🇷 South Korea", id: "south_korea"},
  {title: "🇰🇼 Kuwait", id: "kuwait"},
  {title: "🇰🇿 Kazakhstan", id: "kazakhstan"},
  {title: "🇱🇦 Laos", id: "laos"},
  {title: "🇱🇧 Lebanon", id: "lebanon"},
  {title: "🇱🇨 St. Lucia", id: "st_lucia"},
  {title: "🇱🇮 Liechtenstein", id: "liechtenstein"},
  {title: "🇱🇰 Sri Lanka", id: "sri_lanka"},
  {title: "🇱🇷 Liberia", id: "liberia"},
  {title: "🇱🇸 Lesotho", id: "lesotho"},
  {title: "🇱🇹 Lithuania", id: "lithuania"},
  {title: "🇱🇺 Luxembourg", id: "luxembourg"},
  {title: "🇱🇻 Latvia", id: "latvia"},
  {title: "🇱🇾 Libya", id: "libya"},
  {title: "🇲🇦 Morocco", id: "morocco"},
  {title: "🇲🇨 Monaco", id: "monaco"},
  {title: "🇲🇩 Moldova", id: "moldova"},
  {title: "🇲🇪 Montenegro", id: "montenegro"},
  {title: "🇲🇫 St. Martin", id: "st_martin"},
  {title: "🇲🇬 Madagascar", id: "madagascar"},
  {title: "🇲🇰 North Macedonia", id: "north_macedonia"},
  {title: "🇲🇱 Mali", id: "mali"},
  {title: "🇲🇲 Myanmar (Burma)", id: "myanmar"},
  {title: "🇲🇳 Mongolia", id: "mongolia"},
  {title: "🇲🇴 Macao", id: "macao"},
  {title: "🇲🇶 Martinique", id: "martinique"},
  {title: "🇲🇷 Mauritania", id: "mauritania"},
  {title: "🇲🇸 Montserrat", id: "montserrat"},
  {title: "🇲🇹 Malta", id: "malta"},
  {title: "🇲🇺 Mauritius", id: "mauritius"},
  {title: "🇲🇻 Maldives", id: "maldives"},
  {title: "🇲🇼 Malawi", id: "malawi"},
  {title: "🇲🇽 Mexico", id: "mexico"},
  {title: "🇲🇾 Malaysia", id: "malaysia"},
  {title: "🇲🇿 Mozambique", id: "mozambique"},
  {title: "🇳🇦 Namibia", id: "namibia"},
  {title: "🇳🇨 New Caledonia", id: "new_caledonia"},
  {title: "🇳🇪 Niger", id: "niger"},
  {title: "🇳🇬 Nigeria", id: "nigeria"},
  {title: "🇳🇮 Nicaragua", id: "nicaragua"},
  {title: "🇳🇱 Netherlands", id: "netherlands"},
  {title: "🇲🇵 Northern Mariana Islands", id: "northern_mariana_islands"},
  {title: "🇳🇴 Norway", id: "norway"},
  {title: "🇳🇵 Nepal", id: "nepal"},
  {title: "🇳🇷 Nauru", id: "nauru"},
  {title: "🇳🇺 Niue", id: "niue"},
  {title: "🇳🇿 New Zealand", id: "new_zealand"},
  {title: "🇴🇲 Oman", id: "oman"},
  {title: "🇵🇦 Panama", id: "panama"},
  {title: "🇵🇪 Peru", id: "peru"},
  {title: "🇵🇫 French Polynesia", id: "french_polynesia"},
  {title: "🇵🇬 Papua New Guinea", id: "papua_new_guinea"},
  {title: "🇵🇸 Palestinian Territories", id: "palestinian_territories"},
  {title: "🇵🇭 Philippines", id: "philippines"},
  {title: "🇵🇰 Pakistan", id: "pakistan"},
  {title: "🇵🇱 Poland", id: "poland"},
  {title: "🇵🇷 Puerto Rico", id: "puerto_rico"},
  {title: "🇵🇹 Portugal", id: "portugal"},
  {title: "🇵🇼 Palau", id: "palau"},
  {title: "🇵🇾 Paraguay", id: "paraguay"},
  {title: "🇶🇦 Qatar", id: "qatar"},
  {title: "🇷🇪 Réunion", id: "reunion"},
  {title: "🇷🇴 Romania", id: "romania"},
  {title: "🇷🇸 Serbia", id: "serbia"},
  {title: "🇷🇺 Russia", id: "russia"},
  {title: "🇷🇼 Rwanda", id: "rwanda"},
  {title: "🇸🇦 Saudi Arabia", id: "saudi_arabia"},
  {title: "🇸🇨 Seychelles", id: "seychelles"},
  {title: "🇸🇩 Sudan", id: "sudan"},
  {title: "🇸🇪 Sweden", id: "sweden"},
  {title: "🇸🇬 Singapore", id: "singapore"},
  {title: "🇸🇭 St. Helena", id: "st_helena"},
  {title: "🇸🇮 Slovenia", id: "slovenia"},
  {title: "🇸🇰 Slovakia", id: "slovakia"},
  {title: "🇸🇱 Sierra Leone", id: "sierra_leone"},
  {title: "🇸🇲 San Marino", id: "san_marino"},
  {title: "🇸🇳 Senegal", id: "senegal"},
  {title: "🇸🇴 Somalia", id: "somalia"},
  {title: "🇸🇷 Suriname", id: "suriname"},
  {title: "🇸🇸 South Sudan", id: "south_sudan"},
  {title: "🇸🇻 El Salvador", id: "el_salvador"},
  {title: "🇸🇽 Sint Maarten", id: "sint_maarten"},
  {title: "🇸🇾 Syria", id: "syria"},
  {title: "🇸🇿 Eswatini", id: "eswatini"},
  {title: "🇹🇦 Tristan Da Cunha", id: "tristan_da_cunha"},
  {title: "🇹🇩 Chad", id: "chad"},
  {title: "🇹🇬 Togo", id: "togo"},
  {title: "🇹🇭 Thailand", id: "thailand"},
  {title: "🇹🇯 Tajikistan", id: "tajikistan"},
  {title: "🇹🇰 Tokelau", id: "tokelau"},
  {title: "🇹🇱 Timor-Leste", id: "timor_leste"},
  {title: "🇹🇲 Turkmenistan", id: "turkmenistan"},
  {title: "🇹🇳 Tunisia", id: "tunisia"},
  {title: "🇹🇴 Tonga", id: "tonga"},
  {title: "🇹🇷 Turkey", id: "turkey"},
  {title: "🇹🇹 Trinidad & Tobago", id: "trinidad_tobago"},
  {title: "🇹🇻 Tuvalu", id: "tuvalu"},
  {title: "🇹🇼 Taiwan", id: "taiwan"},
  {title: "🇹🇿 Tanzania", id: "tanzania"},
  {title: "🇺🇦 Ukraine", id: "ukraine"},
  {title: "🇺🇬 Uganda", id: "uganda"},
  {title: "🇺🇳 United Nations", id: "united_nations"},
  {title: "🇺🇸 United States", id: "united_states"},
  {title: "🇺🇾 Uruguay", id: "uruguay"},
  {title: "🇺🇿 Uzbekistan", id: "uzbekistan"},
  {title: "🇻🇦 Vatican City", id: "vatican_city"},
  {title: "🇻🇪 Venezuela", id: "venezuela"},
  {title: "🇻🇳 Vietnam", id: "vietnam"},
  {title: "🇻🇺 Vanuatu", id: "vanuatu"},
  {title: "🇼🇫 Wallis & Futuna", id: "wallis_futuna"},
  {title: "🇼🇸 Samoa", id: "samoa"},
  {title: "🇽🇰 Kosovo", id: "kosovo"},
  {title: "🇾🇪 Yemen", id: "yemen"},
  {title: "🇾🇹 Mayotte", id: "mayotte"},
  {title: "🇿🇦 South Africa", id: "south_africa"},
  {title: "🇿🇲 Zambia", id: "zambia"},
  {title: "🇿🇼 Zimbabwe", id: "zimbabwe"},
  {title: "🏴 England", id: "england"},
  {title: "🏴 Scotland", id: "scotland"},
  {title: "🏴 Wales", id: "wales"},
  {title: "🇫🇴 The Faroe Islands", id: "faroe_islands"}
];